import { useEffect } from "react"
import { useLocale } from "../context/LocaleContext"
import { isLangParamEnabled, readLangParam, urlLangToRegion, withLangParam } from "../i18n/urlLang"

const LangUrlSync = ({ location }) => {
	const { locale, langInUrl, setLocale } = useLocale()
	const pathname = location?.pathname ?? ""
	const search = location?.search ?? ""

	useEffect(() => {
		if (!isLangParamEnabled() || typeof window === "undefined") return
		const region = urlLangToRegion(readLangParam(search))
		if (region) {
			if (region !== locale) setLocale(region, "url")
			return
		}
		if (!langInUrl) return
		const current = window.location
		window.history.replaceState(
			window.history.state,
			"",
			`${current.pathname}${withLangParam(current.search, locale)}${current.hash}`
		)
	}, [pathname, search])

	return null
}

export default LangUrlSync
